// extracted by mini-css-extract-plugin
export default {"allProducts":"AllProducts_allProducts__Gti-i","table":"AllProducts_table__nPnJU","action":"AllProducts_action__t+7HW","procedure":"AllProducts_procedure__YJ0UM"};